module.exports = __webpack_public_path__ + "img/client-large.cd5a48b8.jpg";